/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 日志埋点接口封装
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-10-11 17:38:08
 * @LastEditTime: 2022-10-14 15:22:32
 * @FilePath: /client-h5-v2/src/apis/pringlog/printlog.ts
 */

import httpRequest from '@/request/index'

// eslint-disable-next-line no-undef
export function apiPrintLog (param: LogDataParam) {
  return httpRequest({
    url: '/api/v1/printLog',
    method: 'post',
    data: param
  })
}

import store from '@/store/index'
// eslint-disable-next-line no-undef
export function apiPrintLogWebview (param: LogDataParam) {
  return httpRequest({
    url: `/${store.getters['global/channel']}/api/v1/printLog`,
    method: 'post',
    data: param
  })
}

